import React, { useState } from 'react';
import { Box, TextInput } from '@mantine/core';

/** Champs hors écran : Safari/macOS remplit souvent ceux-ci au lieu du champ visible */
const HONEYPOT_STYLE = {
  position: 'absolute',
  left: '-9999px',
  width: 1,
  height: 1,
  opacity: 0,
  pointerEvents: 'none',
};

/**
 * Champ de filtre / recherche — évite l’autofill identifiant (Trousseau iCloud sur localhost).
 */
export default function SearchFilterInput({
  value,
  onChange,
  placeholder = 'Rechercher…',
  leftSection,
  size = 'sm',
  style,
  'aria-label': ariaLabel = 'Recherche',
  name = 'jlfc-search-filter',
}) {
  const [editable, setEditable] = useState(false);

  const activate = () => {
    if (!editable) setEditable(true);
  };

  return (
    <Box
      component="form"
      autoComplete="off"
      onSubmit={(e) => e.preventDefault()}
      style={{ position: 'relative', ...style }}
    >
      <input
        type="text"
        name="jlfc-decoy-username"
        tabIndex={-1}
        autoComplete="username"
        aria-hidden="true"
        style={HONEYPOT_STYLE}
        defaultValue=""
      />
      <input
        type="password"
        name="jlfc-decoy-password"
        tabIndex={-1}
        autoComplete="current-password"
        aria-hidden="true"
        style={HONEYPOT_STYLE}
        defaultValue=""
      />
      <TextInput
        placeholder={placeholder}
        type="search"
        name={name}
        id={name}
        autoComplete="off"
        autoCorrect="off"
        spellCheck={false}
        role="searchbox"
        aria-label={ariaLabel}
        value={value}
        readOnly={!editable}
        onFocus={activate}
        onMouseDown={activate}
        onChange={onChange}
        leftSection={leftSection}
        size={size}
        data-form-type="search"
      />
    </Box>
  );
}
